/* eslint-disable react/prop-types */
import React, { Component } from "react";
import Navbar from "react-bootstrap/lib/Navbar";
import Nav from "react-bootstrap/lib/Nav";
import NavItem from "react-bootstrap/lib/NavItem";
import NavDropdown from "react-bootstrap/lib/NavDropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";
import { withRouter } from "react-router-dom";
import { Icon, Image, Flag, Dimmer, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import { livelistAction, topologyAction, logAction, configAction, trafficAction, inventoryAction, tsExpertAction } from "../../actions/changeActiveItemActions";
import Constants from "../utilities/Constants";
import Utils from "../utilities/Utils";
import Strings from "../utilities/StringSelector";
const UtilsInstance = new Utils();

class BootstrapMenuBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      languageKey: localStorage.getItem(Constants.LOCAL_STORAGE_KEY),
      language: UtilsInstance.getLanguageStringFromKey(Constants, Strings),
      isUpdatingLanguageDimmerActive: false
    };
  }

  handleSelect = (eventKey) => {
    switch (eventKey) {
      case "/": this.props.onChangeTSExpert(); this.props.history.push("/"); break;
      case "/livelist": this.props.onChangeLiveList(); this.props.history.push("/livelist"); break;
      case "/inventory": this.props.onChangeInventory(); this.props.history.push("/inventory"); break;
      case "/topology": this.props.onChangeTopology(); this.props.history.push("/topology"); break;
      case "/traffic": this.props.onChangeTraffic(); this.props.history.push("/traffic"); break;
      case "/log": this.props.onChangeLog(); this.props.history.push("/log"); break;
      case "/config": this.props.onChangeConfig(); this.props.history.push("/login-handler"); break;
      default: break;
    }
  };

  handleLanguageChange = (lang) => this.sendLanguageData(lang);

  sendLanguageData = (lang) => {
    this.setState({ isUpdatingLanguageDimmerActive: true }, () => {
      fetch(Constants.REQUEST_IP_ADDRESS + "language_POST", {
        method: "POST", headers: { "Content-Type": "application/json;charset=UTF-8" }, body: JSON.stringify({ language: lang })
      })
        .then(UtilsInstance.checkStatus)
        .then(() => { localStorage.setItem(Constants.LOCAL_STORAGE_KEY, lang); window.location.reload(); })
        .catch(error => alert(Strings.UNABLE_TO_ALTER_LANGUAGE + Strings.REASON_DP + error))
        .finally(() => this.setState({ isUpdatingLanguageDimmerActive: false }));
    });
  };

  getNavIconName = (eventKey) => ({
    "/": "brain", "/livelist": "heartbeat", "/inventory": "archive", "/topology": "sitemap",
    "/traffic": "exchange", "/log": "file text outline", "/config": "cog"
  }[eventKey] || "circle outline");

  renderNavIcon = (iconName) => {
    if (iconName === "brain") {
      return <svg className="ts-nav-custom-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M8.3 5.2c-1.6 0-2.9 1.2-3 2.8-1.3.4-2.2 1.6-2.2 3 0 1.3.8 2.5 2 3-.1 1.6 1.1 3 2.8 3.1.6 1.1 1.8 1.8 3.1 1.8h1V5.1H8.3z"/><path d="M15.7 5.2c1.6 0 2.9 1.2 3 2.8 1.3.4 2.2 1.6 2.2 3 0 1.3-.8 2.5-2 3 .1 1.6-1.1 3-2.8 3.1-.6 1.1-1.8 1.8-3.1 1.8h-1V5.1h3.7z"/></svg>;
    }
    return <Icon name={iconName} />;
  };

  renderNavContent = (iconName, text) => <span className="ts-nav-link-content"><span className="ts-nav-icon-badge">{this.renderNavIcon(iconName)}</span><span className="ts-nav-text">{text}</span></span>;
  renderNavItem = (eventKey, activeItem, text, showIcon = false) => <NavItem className="ts-main-nav-item" style={fontStyle} eventKey={eventKey} active={activeItem === eventKey}>{showIcon ? this.renderNavContent(this.getNavIconName(eventKey), text) : <span className="ts-nav-text">{text}</span>}</NavItem>;

  render() {
    let activeItem = "/" + this.props.location.pathname.split("/")[1];
    if (["/login","/login-handler","/report","/change-login","/blacklist","/edit-gsdml","/tags","/sweep","/wlan-config","/office-ethernet-config","/ethernet-config","/ts-expert-config"].includes(activeItem)) activeItem = "/config";
    if (activeItem === "/graphic-topology") activeItem = "/topology";

    return <>
      <Navbar fluid defaultExpanded inverse collapseOnSelect className="ts-main-navbar" style={menuStyle}>
        <Navbar.Header><Navbar.Brand><Image className="ts-navbar-logo" style={noBorderStyle} src={`${process.env.PUBLIC_URL}/logo.png`} alt="TS Monitor Logo" as="button" onClick={() => this.handleSelect("/")} /></Navbar.Brand><Navbar.Toggle /></Navbar.Header>
        <Navbar.Collapse>
          <Nav className="ts-main-nav-group" pullLeft bsStyle="pills" onSelect={this.handleSelect} activeKey={this.props.active}>
            {this.renderNavItem("/", activeItem, Strings.TS_EXPERT)}
          </Nav>

          <Nav className="ts-main-nav-group" pullLeft bsStyle="pills" onSelect={this.handleSelect} activeKey={this.props.active}>
            {this.renderNavItem("/livelist", activeItem, Strings.LIVE_LIST)}
          </Nav>

          <Nav className="ts-main-nav-group" pullLeft bsStyle="pills" onSelect={this.handleSelect} activeKey={this.props.active}>
            {this.renderNavItem("/inventory", activeItem, Strings.INVENTORY)}
          </Nav>

          <Nav className="ts-main-nav-group" pullLeft bsStyle="pills" onSelect={this.handleSelect} activeKey={this.props.active}>
            {this.renderNavItem("/topology", activeItem, Strings.TOPOLOGY)}
          </Nav>

          <Nav className="ts-main-nav-group" pullLeft bsStyle="pills" onSelect={this.handleSelect} activeKey={this.props.active}>
            {this.renderNavItem("/traffic", activeItem, Strings.DROPDOWN_TRAFFIC)}
          </Nav>

          <Nav className="ts-main-nav-group" pullLeft bsStyle="pills" onSelect={this.handleSelect} activeKey={this.props.active}>
            {this.renderNavItem("/log", activeItem, Strings.LOG)}
          </Nav>

          <Nav className="ts-main-nav-group ts-main-nav-right" pullRight bsStyle="pills" onSelect={this.handleSelect} activeKey={this.props.active}>
            <NavDropdown
              role="menuitem"
              id="language-dropdown"
              className="ts-main-nav-item ts-language-nav-dropdown"
              eventKey={this.state.languageKey}
              title={this.renderNavContent("world", this.state.language)}
              onSelect={this.handleLanguageChange}>
              <MenuItem eventKey="pt"><Flag name="br" />{Strings.PORTUGUESE}</MenuItem>
              <MenuItem eventKey="en"><Flag name="us" />{Strings.ENGLISH}</MenuItem>
              <MenuItem eventKey="es"><Flag name="es" />{Strings.SPANISH}</MenuItem>
              <MenuItem eventKey="de"><Flag name="de" />{Strings.GERMAN}</MenuItem>
            </NavDropdown>
            {this.renderNavItem("/config", activeItem, Strings.CONFIG, true)}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <Dimmer page active={this.state.isUpdatingLanguageDimmerActive}><Loader size="big">{Strings.UPDATING_LANGUAGE_WAITING}</Loader></Dimmer>
    </>;
  }
}

const mapStateToProps = state => ({ active: state.activeMenuItem });
const mapActionsToProps = { onChangeTSExpert: tsExpertAction, onChangeLiveList: livelistAction, onChangeInventory: inventoryAction, onChangeTopology: topologyAction, onChangeTraffic: trafficAction, onChangeLog: logAction, onChangeConfig: configAction };
const menuStyle = { backgroundColor: "#262626", padding: "8pt", borderRadius: "0pt", borderWidth: 0 };
const fontStyle = { fontSize: "medium" };
const noBorderStyle = { border: "none", background: "none", width: "68px", height: "34px", maxHeight: "34px", objectFit: "contain", padding: 0, marginTop: "2px", cursor: "pointer" };
export default connect(mapStateToProps, mapActionsToProps)(withRouter(BootstrapMenuBar));

